/** Anchor Targets Enum
    @readonly
    @enum {string}
*/
export var ANCHORTARGETS;
(function (ANCHORTARGETS) {
    ANCHORTARGETS["SELF"] = "_self";
    ANCHORTARGETS["BLANK"] = "_blank";
    ANCHORTARGETS["PARENT"] = "_parent";
    ANCHORTARGETS["TOP"] = "_top";
})(ANCHORTARGETS || (ANCHORTARGETS = {}));
;
